import { useNavigate } from 'react-router';
import { styled } from 'styled-components';

import { Button } from 'components/Button/Button';
import { BodySmall } from 'components/Text/BodySmall';
import { useI18n } from 'i18n/hooks/useI18n';
import { createOrgRoute } from 'routing/routes';
import { colors } from 'theme/theme';

const ChangeEntityContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

const EntityName = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 16px;
  font-size: 16px;
  border-right: 1px solid ${colors.selectionGrey};
`;

type Props = {
  name: string;
  from: string | null | undefined;
  hasSingleEntity?: boolean;
};

export function PostAListingPageChangeEntity({
  name,
  from,
  hasSingleEntity,
}: Props) {
  const { i18n } = useI18n();
  const navigate = useNavigate();

  return (
    <ChangeEntityContainer>
      <EntityName>{name}</EntityName>
      {hasSingleEntity ? (
        <Button
          type="button"
          variant="tertiary"
          onClick={() =>
            navigate(createOrgRoute.with({}), {
              state: {
                from,
              },
            })
          }
        >
          <BodySmall>{i18n('Create New Organization')}</BodySmall>
        </Button>
      ) : (
        <Button
          type="button"
          variant="tertiary"
          onClick={() => navigate('/post-a-listing', { state: { from } })}
        >
          <BodySmall>{i18n('Change Organization')}</BodySmall>
        </Button>
      )}
    </ChangeEntityContainer>
  );
}
